module.exports = __webpack_public_path__ + "img/icon_memo_blue.7b9c2268.png";